import { createAsyncThunk } from '@reduxjs/toolkit';
import { gatewayRequestAxios } from '../../services/interceptor';

import { GATEWAY_API_USERS_URL } from '../../constants/urls';

const getParamsForGetUsers = (filter) => {
  const params = { limit: 500, extended_properties: true }
  if (filter) {
    params.q = filter;
  }
  return params
}

export const getUsers = createAsyncThunk('users', async (filter) => {
  const response = await gatewayRequestAxios.get(GATEWAY_API_USERS_URL, {
    params: getParamsForGetUsers(filter),
  });
  return response.data;
});
